import { Tenor } from "shared/cubiq-model-multi-asset";
import { Rate } from "./Rate";

export class RateSubscription {
  constructor(
    public readonly assetCode: string,
    public readonly product: string,
    public readonly tenor: Tenor = Tenor.EMPTY,
    public readonly valueDate: Date = null,
  ) {
    if (Tenor.EMPTY !== tenor && valueDate instanceof Date) {
      throw Error(`Invalid ${this.toString()}`);
    } else if ((Tenor.EMPTY === tenor || tenor == null) && valueDate instanceof Date === false) {
      throw Error(`Invalid ${this.toString()}`);
    }
  }

  public toString(): string {
    let valueDate =
      this.valueDate != null
        ? `${this.valueDate.getDate()}-${
            this.valueDate.getMonth() + 1
          }-${this.valueDate.getFullYear()}`
        : null;
    let tenor = this.tenor != null ? Tenor[this.tenor] : null;

    return `RateSubscription[assetCode:${this.assetCode},product:${this.product},tenor:${tenor},valueDate:${valueDate}}]`;
  }

  public get key(): string {
    return Rate.getRateKey(this.assetCode, this.product, this.tenor, this.valueDate);
  }
}
